import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Vuetify from 'vuetify';
import Ads from 'vue-google-adsense'
import titleMixin from './mixins/titleMixin'
import colors from 'vuetify/es5/util/colors';
import 'vuetify/dist/vuetify.min.css';
import '@/assets/scss/mpc.scss';
import '@mdi/font/css/materialdesignicons.css';

Vue.config.productionTip = false;

Vue.use(require('vue-script2'));

Vue.use(Ads.Adsense);

Vue.mixin(titleMixin);

Vue.use(Vuetify, {
    iconfont: 'mdi',
    theme: {
        primary: colors.red.darken4,
        secondary: colors.red.lighten4,
        accent: colors.indigo.base
    }
});


new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
